import { memo } from "react";
import {
  Button,
  Flex,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@repo/ping-design";
import { LatLngType } from "../../ts-types/mapsTypes";
import { PING_GEOCODING_SEARCH_COLOR } from "../../constants/maps-constants";
import "./SearchedAddressLegendItem.scss";

type SearchedAddressLegendItemProps = {
  address: string;
  latLng: LatLngType;
  onClick?: (latLng: LatLngType) => void;
  onAnnotationAdded?: (latLng: LatLngType) => void;
  onMouseOver?: (s: string | null) => void;
  classNamePrefix?: string;
};

export const SearchedAddressLegendItem = memo(
  ({
    address,
    latLng,
    onClick,
    onAnnotationAdded,
    onMouseOver,
    classNamePrefix = "SearchedAddressLegendItem",
  }: SearchedAddressLegendItemProps) => {
    return (
      <Flex direction="row" justify="space-between">
        <Flex className={`${classNamePrefix}__Left`} gap="2" align="center">
          <div
            className={`${classNamePrefix}__Left__Color`}
            style={{
              backgroundColor: PING_GEOCODING_SEARCH_COLOR,
            }}
          />
          <span className={`${classNamePrefix}__Left__Address`}>{address}</span>
        </Flex>
        <Flex
          className={`${classNamePrefix}__Right`}
          gap="2"
          align="center"
          justify="space-between"
        >
          <Tooltip placement="top">
            <TooltipTrigger asChild>
              <Button
                iconName="MapPinCheckInside"
                size="sm"
                variant="outline"
                onClick={() => {
                  onAnnotationAdded?.(latLng);
                }}
              />
            </TooltipTrigger>
            <TooltipContent>Set as Geocoding</TooltipContent>
          </Tooltip>
          <Tooltip placement="top">
            <TooltipTrigger asChild>
              <Button
                iconName="LocateFixed"
                size="sm"
                variant="outline"
                onClick={() => {
                  onClick?.(latLng);
                }}
                onMouseOver={() => {
                  onMouseOver?.("SEARCH");
                }}
                onMouseOut={() => {
                  onMouseOver?.(null);
                }}
              />
            </TooltipTrigger>
            <TooltipContent>Jump to location</TooltipContent>
          </Tooltip>
        </Flex>
      </Flex>
    );
  },
);

SearchedAddressLegendItem.displayName = "SearchedAddressLegendItem";
